import instance from 'api';
import { IRole } from 'interfaces';
import { IExtraRoleReq } from './interface';

export const getExtraRoleList = () => {
  return instance()
    .post('/extraRoleAdmin/list', {})
    .then((response) => response.data);
};

export const getExtraRolePagedList = (data: IExtraRoleReq) => {
  return instance()
    .post('/extraRoleAdmin/pagedList', data)
    .then((response) => response.data);
};

export const saveExtraRole = (role: string, userId: string) => {
  return instance()
    .post('/extraRoleAdmin/save', { role, userId })
    .then((response) => response.data);
};

export const deleteExtraRole = (role: number, userId: string) => {
  return instance()
    .post('/extraRoleAdmin/delete', { roleId: role, userId })
    .then((response) => response.data);
};

export const getAllRoles = (): Promise<IRole[]> => {
  return instance()
    .post('/security/allRolesAdmin', {})
    .then((response) => response.data);
};

export const getPositions = () => {
  return instance()
    .post('/dictionary/positions', {})
    .then((response) => response.data);
};
